<template>
    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-text-field
            v-model="obraSocial.nombre"
            :rules="obligatorioAlfabetico"
            label="Nombre"
            required
            variant="solo"
        ></v-text-field>
        <v-text-field 
            label="Cantidad maxima de prestaciones por orden" 
            variant="solo"
            v-model="obraSocial.cantMaxPrestacionesPorOrden"
            type="number"
            :rules="obligatorioNumerico"
            class="asterisco"
        >
        </v-text-field>
        <v-autocomplete
            v-model="obraSocial.tipoServicio"
            :items="tiposServicio"
            item-title="nombre"
            item-value="nombre"
            variant="solo"
            label="Seleccione un tipo de servicio"
            auto-select-first="true"
            no-data-text="No se encontraron resultados"
            class="asterisco"
            :loading="cargandoTiposServicios"
            >
        </v-autocomplete>
        <v-autocomplete
            v-model="obraSocial.grupoId"
            :items="grupos"
            item-title="nombre"
            item-value="id"
            variant="solo"
            label="Seleccione un grupo"
            auto-select-first="true"
            no-data-text="No se encontraron resultados"
            class="asterisco"
            :loading="cargadoGrupos"
            >
        </v-autocomplete>
        <div>
            <label class="my-text-black">Configuraciones: </label>
            <v-checkbox
                label="Requiere número de autorización manual"               
                v-model="obraSocial.requiereNroAutorizacionManual"
            ></v-checkbox>
            <v-checkbox
                label="Acepta numero de autorizacion cero"               
                v-model="obraSocial.aceptaNroAutorizacionCero"
            ></v-checkbox>
            <v-checkbox
                label="Requiere carnet afiliado"                
                v-model="obraSocial.requiereCarnetAfiliado"
            ></v-checkbox>
            <v-checkbox
                label="Requiere numero de validacion manual"               
                v-model="obraSocial.requiereNroValidacionManual"
            ></v-checkbox>
            <v-checkbox
                label="Acepta numero de validacion cero"                
                v-model="obraSocial.aceptaNroValidacionCero"
            ></v-checkbox>
            <v-checkbox
                label="Requiere token"                
                v-model="obraSocial.requiereToken"
            ></v-checkbox>
            <v-checkbox
                label="Acepta token cero"                
                v-model="obraSocial.aceptaTokenCero"
            ></v-checkbox>
            <v-checkbox
                label="Puede autorizar por prestacion"                
                v-model="obraSocial.puedeAutorizarPorPrestacion"
            ></v-checkbox>
            <v-checkbox
                label="Puede sobreescribir copago"                
                v-model="obraSocial.puedeSobreescribirCopago"
            ></v-checkbox>
            <v-checkbox
                label="Ingreso copago obligatorio"                
                v-model="obraSocial.ingresoCopagoObligatorio"
            ></v-checkbox>
            <v-checkbox
                label="Requiere numero afiliado manual"               
                v-model="obraSocial.requiereNroAfiliadoManual"
            ></v-checkbox>
            <v-checkbox
                label="Acepta bono adicional"                
                v-model="obraSocial.aceptaBonoAdicional"
            ></v-checkbox>
        </div>
        <v-btn
            type="submit"
            :disabled="!valid"
            id="boton-verde"
            :loading="cargando"
        >
            Agregar obra social
        </v-btn>
    </v-form>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        titulo="Agregar obra social"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorioAlfabetico, obligatorioNumerico } from '@/_helpers/rules';
    import PacienteService from '@/api/PacienteService';
    import AdminService from '@/api/AdminService';
    import ClosableAlert from '@/components/ClosableAlert';

    const pacienteService = new PacienteService();
    const adminService = new AdminService();

    export default {
        components: {
            ClosableAlert,
        },
        data() {
            return {
                valid: true,
                cargando: false,
                obraSocial: {
                    nombre: '',
                    tipoServicio: null,
                    grupoId: null,
                    requiereNroAutorizacionManual: false,
                    aceptaNroAutorizacionCero: false,
                    requiereCarnetAfiliado: false,
                    requiereNroValidacionManual: false,
                    aceptaNroValidacionCero: false,
                    requiereToken: false,
                    aceptaTokenCero: false,
                    puedeAutorizarPorPrestacion: false,
                    puedeSobreescribirCopago: false,
                    ingresoCopagoObligatorio: false,
                    requiereNroAfiliadoManual: false,
                    aceptaBonoAdicional: false,
                    cantMaxPrestacionesPorOrden: null,
                },
                tiposServicio: [],
                grupos: [],
                cargandoTiposServicios: false,
                cargadoGrupos: false,
                //reglas
                obligatorioAlfabetico: obligatorioAlfabetico,
                obligatorioNumerico: obligatorioNumerico,
                //alerta
                alert: false,
                alertType: '',
                alertKey: 0,
                mensaje: '',
            };
        },
        async mounted() {
            await this.cargarTiposServicios();
            await this.cargarGrupos();
        },
        methods: {
            async handleSubmit() {
                this.cargando = true;
                this.obraSocial.cantMaxPrestacionesPorOrden = parseInt(this.obraSocial.cantMaxPrestacionesPorOrden);
                const response = await adminService.crearObraSocial(this.obraSocial);
                if(response && response.status === 200) {
                    if(response.data == false){
                        this.alertType = 'info';
                        this.mensaje = 'Obra social existente';
                    } else {
                        this.alertType = 'success';
                        this.mensaje = 'Obra social creada con éxito';
                    }
                } else {
                    this.alertType = 'info';
                    this.mensaje = 'Error al crear la obra social';
                }
                this.alert = true;
                this.alertKey += 1;
                this.cargando = false;
            },
            async cargarTiposServicios(){
                this.cargandoTiposServicios = true;
                const response = await pacienteService.getTiposServicio();
                if(response && response.status === 200){
                    this.tiposServicio = response.data;
                }
                this.cargandoTiposServicios = false;
            },
            async cargarGrupos(){
                this.cargadoGrupos = true;
                const response = await pacienteService.getGrupos();
                if(response && response.status === 200){
                    this.grupos = response.data;
                }
                this.cargadoGrupos = false;
            },
        }
    };
</script>